import React, { FC } from 'react';
import { useHistory } from 'react-router';

import {
	BUTTON_TYPES,
	EvButton,
	EvEllipsedTextWithTooltip,
	EvFlexColumn,
	EvFlexRow
} from '@evinced-private/ui-common';

import { ALL_CONTENT_VIEW_ID } from '../../../../components/common/ev-property-views/consts/PropertyViews';
import { ScreenshotCellFormatter } from '../../../../components/scan-analysis/table-formatters/screenshot-cell-formatter/ScreenshotCellFormatter';
import { RoutesHelper } from '../../../../helpers/RoutesHelper';
import { roundScore } from '../../../../helpers/ScoreHelper';
import { TQuickWin } from '../../DashboardTypes';
import { Box } from '../box/Box';

import './QuickWin.scss';

interface IQuickWin {
	quickWin: TQuickWin;
}

const exploreTitle = 'Explore';

const MAX_PROPERTY_NAME_LENGTH = 205;

const QuickWin: FC<IQuickWin> = ({ quickWin }) => {
	const history = useHistory();

	if (quickWin.criticalIssuesPercentage < 2) {
		return null;
	}

	return (
		<Box className="quick-win">
			<div>
				<div className="resolve-precentage">
					Resolve
					<span className="precentage">
						{` ${roundScore(quickWin.criticalIssuesPercentage)}% `}
					</span>
					of critical issues
				</div>
				<div className="property-name">
					<span className="in-prefix">in</span>
					<EvEllipsedTextWithTooltip
						text={quickWin.property.name}
						maxWidth={MAX_PROPERTY_NAME_LENGTH}
						showTooltipOnlyOnEllipsed
					/>
				</div>
				<div className="by-fixing">{`By fixing ${quickWin.componentsCount} components`}</div>
			</div>
			<div className="screenshot">
				<ScreenshotCellFormatter
					cellDescriptor="Component sample issue"
					screenshotDetails={{
						pageScreenshotUrl: quickWin.screenshot.pageScreenshotUrl,
						boundingBoxes: [[0, 0, 0, 0]]
					}}
					imageContainerClassName="screenshot-image-container"
					screenshotImgClassName="screenshot-image"
					noCrop={true}
				/>
			</div>
			<EvFlexRow justify="END">
				<EvButton
					type={BUTTON_TYPES.ACTION}
					isFullWidth
					title={`${exploreTitle} the critical issues of property ${quickWin.property.name}`}
					onClick={() =>
						history.push({
							pathname: RoutesHelper.getScanResultComponentsBreakdownPath(
								quickWin.property.id,
								quickWin.property.lastSuccessfulScan.id
							),
							search: `viewId=${ALL_CONTENT_VIEW_ID}`,
							state: {
								severity: 'Critical',
								isTemporary: true
							}
						})
					}
				>
					<EvFlexColumn align="CENTER">{exploreTitle}</EvFlexColumn>
				</EvButton>
			</EvFlexRow>
		</Box>
	);
};

export { QuickWin };
